import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfficeOurServicesComponent } from './office-our-services.component';
import { Routes, RouterModule } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { GlobalPipesModule } from '@app/@shared/pipes/globalPipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { FlexModule } from '@angular/flex-layout';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'our-services', component: OfficeOurServicesComponent, data: { title: marker('Services') } },
    { path: ':officeId/our-services', component: OfficeOurServicesComponent, data: { title: marker('Services') } },
  ]),
];

@NgModule({
  declarations: [OfficeOurServicesComponent],
  imports: [CommonModule, GlobalPipesModule, TranslateModule, FlexModule, FormsModule, RouterModule.forChild(routes)],
})
export class OfficeOurServicesModule {}
